import type { Step } from '@folio/types';
import { generatePath, Navigate, useParams } from 'react-router-dom';
import { Stepper } from './StepperLayout';

// Component to handle navigation while preserving route params
export function NavigateWithParams({ to }: { to: string }) {
  const params = useParams();

  // Use generatePath to reconstruct the path with current parameters
  // This preserves path parameters like :id, :customerId, etc.
  const finalTo = generatePath(to, params);

  return <Navigate to={finalTo} replace />;
}

export function getRoutesFromStepper({
  steps,
  basePath,
  afterEndPath,
  title,
  stepsI18nPrefix,
}: {
  steps: [Step, ...Step[]];
  basePath: string;
  afterEndPath?: string;
  title?: string;
  stepsI18nPrefix?: string;
}) {
  return [
    {
      element: (
        <Stepper
          steps={steps}
          basePath={basePath}
          afterEndPath={afterEndPath}
          title={title}
          stepsI18nPrefix={stepsI18nPrefix}
        />
      ),
      children: [
        ...steps.map(step => ({
          path: `${basePath}/${step.path}`,
          element: step.element,
        })),
        {
          path: basePath,
          element: <NavigateWithParams to={`${basePath}/${steps[0].path}`} />,
        },
      ],
    },
  ];
}
